// extracted by mini-css-extract-plugin
export default {"body":"AppBody_body__E4exQ","editor":"AppBody_editor__SrtoF","editor_body":"AppBody_editor_body__EkVcX","editor_footer":"AppBody_editor_footer__hN+ww"};